<template>
    <div  @keydown.esc="close" ref="modal" tabindex="0" class='vue-modal' :style="{ top: headerTop }" :class="{ 'confirm-internal-pay-modal': this.$store.state.modal.type === 'NotificationInternalPay' }">
    <div class="vue-modal-wrap">
        <div 
        :class="{
            'bg-light-grey': this.$store.state.resize.w > 768 || this.$store.state.modal.type === 'ConfirmInternalPay', 
            'col-12': this.$store.state.resize.w <= 768 && this.$store.state.modal.type !== 'ConfirmInternalPay', 
            'col-10 content': this.$store.state.resize.w > 768 || this.$store.state.modal.type === 'ConfirmInternalPay',
            'p16': this.$store.state.resize.w > 768 || this.$store.state.modal.type === 'ConfirmInternalPay',
            'p24': this.$store.state.resize.w <= 768 && this.$store.state.modal.type !== 'ConfirmInternalPay'
        }"
        class='vue-modal-window neue mx-auto col-xl-6 col-lg-8'
        :style="this.$store.state.resize.w > 768 || this.$store.state.modal.type === 'ConfirmInternalPay' ? `width: ${this.$store.state.modal.content?.width ? this.$store.state.modal.content?.width : 608}px` : ''"
        >
            <Answer v-if="this.$store.state.modal.type == 'answer'" :close="this.close"/>
            <PayStatus v-if="this.$store.state.modal.type == 'pay_status'" :close="this.close"/>
            <PayPass v-if="this.$store.state.modal.type == 'pay_pass'" :close="this.close"/> 
            <Repeat v-if="this.$store.state.modal.type == 'repeat'" :close="this.close"/>
            <Confirm v-if="this.$store.state.modal.type == 'confirm'" :close="this.close"/>
            <HistoryParams v-if="this.$store.state.modal.type == 'history'" :close="this.close"/>
            <MembersModal v-if="this.$store.state.modal.type == 'members'" :close="this.close"/>
            <KeytRename v-if="this.$store.state.modal.type == 'k_rename'" :close="this.close"/>
            <Address v-if="this.$store.state.modal.type == 'address'" :close="this.close"/>
            <SupportList v-if="this.$store.state.modal.type == 'support'" :close="this.close"/>
            <TemplateRename v-if="this.$store.state.modal.type == 'rename'" :close="this.close"/>
            <WidgetData v-if="this.$store.state.modal.type == 'widgetData'" :close="this.close"/>
            <PayHref v-if="this.$store.state.modal.type == 'payHref'" :close="this.close"/>
            <ReEshop v-if="this.$store.state.modal.type == 'changeEshop'" :close="this.close"/>
            <Questionnaire v-if="this.$store.state.modal.type == 'questionnaire'" :close="this.close"/>
            <Emission v-if="this.$store.state.modal.type == 'emission'" :close="this.close"/>
            <EditP2POffer v-if="this.$store.state.modal.type == 'editP2P'" :close="this.close"/>
            <RequestP2POffer v-if="this.$store.state.modal.type == 'requestP2P'" :close="this.close"/>
            <CheckCurrP2P v-if="this.$store.state.modal.type == 'checkCurrP2P'" :close="this.close"/>
            <RequestP2PArbitrage v-if="this.$store.state.modal.type == 'requestArbitrageP2P'" :close="this.close"/>
            <EditExternalP2PCurrencies v-if="this.$store.state.modal.type == 'editExternalP2PCurrencies'" :close="this.close" />
            <ATMIncassStatuses v-if="this.$store.state.modal.type == 'ATMIncassStatuses'" :close="this.close" />
            <CollectorsList v-if="this.$store.state.modal.type == 'CollectorsList'" :close="this.close" />
            <InfoCollector v-if="this.$store.state.modal.type == 'InfoCollector'" :close="this.close" />
            <ChoiseKeyt v-if="this.$store.state.modal.type == 'ChoiseKeyt'" :close="this.close" />
            <ChoiseColumns v-if="this.$store.state.modal.type == 'ChoiseColumns'" :close="this.close" />
            <Warning v-if="this.$store.state.modal.type == 'Warning'" :close="this.close" />
            <BurnCustomCurr v-if="this.$store.state.modal.type == 'BurnCustomCurr'" :close="this.close" />
            <PaySelect v-if="this.$store.state.modal.type == 'PaySelect'" :close="this.close" />
            <AssetDetails v-if="this.$store.state.modal.type == 'AssetDetails'" :close="this.close" />
            <DeleteKeyt v-if="this.$store.state.modal.type == 'DeleteKeyt'" :close="this.close" />
            <TestMoney v-if="this.$store.state.modal.type == 'TestMoney'" :close="this.close" />
            <InvoicesFilter v-if="this.$store.state.modal.type == 'InvoicesFilter'" :close="this.close" />
            <InvoiceDetails v-if="this.$store.state.modal.type == 'InvoiceDetails'" :close="this.close" />
            <HistoryFilter v-if="this.$store.state.modal.type == 'HistoryFilter'" :close="this.close" />
            <OwnershipFilter v-if="this.$store.state.modal.type == 'OwnershipFilter'" :close="this.close" />
            <AddressDetails v-if="this.$store.state.modal.type == 'AddressDetails'" :close="this.close" />
            <AddOwnershipAddress v-if="this.$store.state.modal.type == 'AddOwnershipAddress'" :close="this.close" />
            <P2PFilters v-if="this.$store.state.modal.type == 'P2PFilters'" :close="this.close" />
            <AdInfo v-if="this.$store.state.modal.type == 'AdInfo'" :close="this.close" />
            <RatingP2P v-if="this.$store.state.modal.type == 'RatingP2P'" :close="this.close" />
            <CancelOrder v-if="this.$store.state.modal.type == 'CancelOrder'" :close="this.close" />
            <ConfirmInternalPay v-if="this.$store.state.modal.type == 'ConfirmInternalPay'" :close="this.close" />
            <NotificationInternalPay v-if="this.$store.state.modal.type == 'NotificationInternalPay'" :close="this.close" />
            <CancelP2PArbitrage v-if="this.$store.state.modal.type == 'CancelP2PArbitrage'" :close="this.close" />
            <ExtendP2PTimer v-if="this.$store.state.modal.type == 'ExtendP2PTimer'" :close="this.close" />
            <CreateTemplate v-if="this.$store.state.modal.type == 'CreateTemplate'" :close="this.close" />
            <CreateKeyt v-if="this.$store.state.modal.type == 'CreateKeyt'" :close="this.close" />
            <AssetsFilter v-if="this.$store.state.modal.type == 'AssetsFilter'" :close="this.close" />
        </div>
    </div>
    </div>
</template>

<script>
import Answer from '@/components/service/modals/Answer';
import Confirm from '@/components/service/modals/Confirm';
import PayPass from '@/components/service/modals/PayPass';
import Repeat from '@/components/service/modals/Repeat';
import KeytRename from '@/components/service/modals/KeytRename';
import HistoryParams from '@/components/service/modals/HistoryParams';
import MembersModal from '@/components/service/modals/MembersModal';
import PayStatus from '@/components/service/modals/PayStatus';
import Address from '@/components/service/modals/Address';
import SupportList from '@/components/service/modals/SupportList';
import TemplateRename from '@/components/service/modals/TemplateRename';
import WidgetData from '@/components/service/modals/WidgetData';
import PayHref from '@/components/service/modals/PayHref';
import ReEshop from '@/components/service/modals/ReEshop';
import Questionnaire from '@/components/service/modals/Questionnaire';
import Emission from '@/components/service/modals/Emission';
import EditP2POffer from '@/components/service/modals/p2p/EditP2POffer';
import RequestP2POffer from '@/components/service/modals/p2p/RequestP2POffer';
import ParamsP2PSwap from '@/components/service/p2p/ParamsP2PSwap';
import CheckCurrP2P from './modals/p2p/CheckCurrP2P.vue';
import RequestP2PArbitrage from './modals/p2p/RequestP2PArbitrage.vue';
import EditExternalP2PCurrencies from './modals/p2p/EditExternalP2PCurrencies.vue';
import ATMIncassStatuses from './modals/ATMIncassStatuses.vue';
import CollectorsList from './modals/CollectorsList.vue';
import InfoCollector from './modals/InfoCollector.vue';
import ChoiseKeyt from './modals/ChoiseKeyt.vue';
import ChoiseColumns from './modals/ChoiseColumns.vue';
import Warning from './modals/Warning.vue';
import BurnCustomCurr from './modals/BurnCustomCurr.vue';
import PaySelect from '@/components/service/modals/PaySelect';
import AssetDetails from './modals/AssetDetails.vue'
import DeleteKeyt from './modals/DeleteKeyt.vue';
import TestMoney from './modals/TestMoney.vue';
import InvoicesFilter from './modals/InvoicesFilter.vue';
import InvoiceDetails from './modals/InvoiceDetails.vue';
import HistoryFilter from './modals/HistoryFilter.vue';
import OwnershipFilter from './modals/ownership/OwnershipFilter.vue';
import AddressDetails from './modals/ownership/AddressDetails.vue';
import AddOwnershipAddress from './modals/ownership/AddOwnershipAddress.vue';
import P2PFilters from './modals/p2p/P2PFilters.vue';
import AdInfo from './modals/p2p/AdInfo.vue';
import RatingP2P from './modals/p2p/RatingP2P.vue';
import CancelOrder from './modals/p2p/CancelOrder.vue'; 
import ConfirmInternalPay from './modals/p2p/ConfirmInternalPay.vue';
import NotificationInternalPay from './modals/p2p/NotificationInternalPay.vue';
import CancelP2PArbitrage from './modals/p2p/CancelP2PArbitrage.vue';
import ExtendP2PTimer from './modals/p2p/ExtendP2PTimer.vue';
import CreateTemplate from './modals/СreateTemplate.vue';
import CreateKeyt from './modals/CreateKeyt.vue';
import AssetsFilter from './modals/AssetsFilter.vue';

export default {
    props: {
        title: {
            type: [String]
        }
    },
    components: {
        Answer,
        PayPass,
        Repeat,
        HistoryParams,
        KeytRename,
        Confirm,
        MembersModal,
        PayStatus,
        Address,
        SupportList,
        TemplateRename,
        WidgetData,
        PayHref,
        ReEshop,
        Questionnaire,
        Emission,
        EditP2POffer,
        RequestP2POffer,
        ParamsP2PSwap,
        CheckCurrP2P,
        RequestP2PArbitrage,
        EditExternalP2PCurrencies,
        ATMIncassStatuses,
        CollectorsList,
        InfoCollector,
        ChoiseKeyt,
        ChoiseColumns,
        Warning,
        BurnCustomCurr,
        PaySelect,
        AssetDetails,
        DeleteKeyt,
        TestMoney,
        InvoicesFilter,
        InvoiceDetails,
        HistoryFilter,
        OwnershipFilter,
        AddressDetails,
        AddOwnershipAddress,
        P2PFilters,
        AdInfo,
        RatingP2P,
        CancelOrder,
        ConfirmInternalPay,
        NotificationInternalPay,
        CancelP2PArbitrage,
        ExtendP2PTimer,
        CreateTemplate,
        CreateKeyt,
        AssetsFilter
    },
    data() {
        return {
            widths: {
                payHref: '672',
                paySelect: '608',
            },
            headerTop: '0px',
            resizeObserver: null
        }
    },
    created() {
        this.getModalWidth(); // Добавлено для перехода на новую дизайнсистему - после перехода, по возможности убрать
    },
    mounted() {
        this.$refs.modal.focus();
        document.querySelector('body').style.overflow = 'hidden';
        this.$store.commit('DARK_WRAPPER', true);
        this.updateHeaderTop();
        this.setupResizeObserver();
    },
    unmounted() {
        document.querySelector('body').style.overflow = 'auto';
        this.cleanupResizeObserver();
    },
    methods: {
        close() {
            this.$store.commit('MODAL', {
                                        action: false,
                                        type: false,
                                        content: false,
                                        }
                                );
            this.$store.commit('DARK_WRAPPER', false);
        },
        getModalWidth() {
            if (this.$store.state.modal.type in this.widths) {
                this.$store.state.modal.content.width = this.widths[this.$store.state.modal.type];
            }
        },
        updateHeaderTop() {
            const header = document.querySelector('.header-wrapper');
            if (header) {
                this.headerTop = `${header.offsetHeight}px`;
            }
        },
        setupResizeObserver() {
            const header = document.querySelector('.header-wrapper');
            if (header && window.ResizeObserver) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.updateHeaderTop();
                });
                this.resizeObserver.observe(header);
            }
        },
        cleanupResizeObserver() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        }
    },
}
</script>

<style lang="scss">
    .vue-modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        min-height: 100%;
        padding-top: 100px;
        padding-bottom: 100px;
        width: 100%;
        // background: rgba(0, 0, 0, 0.3); // Make sure this color has an opacity of less than 1
        z-index: 8999;
        outline: none;
        overflow: auto;
        .vue-modal-wrap {
            flex-shrink: 0;
            flex-grow: 0;
            width: 100%;
            min-height: 100%;
            margin: auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;

            @media (max-width: 768px) {
                justify-content: start;
            }
            
            // Исключение для ConfirmInternalPay - оставляем центрирование
            .confirm-internal-pay-modal & {
                @media (max-width: 768px) {
                    justify-content: center;
                }
            }
            .vue-modal-window {
                flex-shrink: 0;
                flex-grow: 0;
                max-width: 100%;
                overflow: visible;
                border-radius: 16px;
            }
        }
        @media (max-width: 768px) {
            &:not(.confirm-internal-pay-modal) {
                top: 54px;
                padding-top: 0px;
                background-color: white;
                .vue-modal-wrap {
                    .vue-modal-window {
                        height: calc(100% - 54px);
                    }
                }
            }
        }
    }
    .content_width {
        width: min-content !important;
        @media screen and (max-width: 974px) {
            width: 83.33333333% !important;
        }
    }

    .confirm-internal-pay-modal .vue-modal-wrap {
        @media (max-width: 768px) {
            justify-content: center;
        }
    }
</style>
